import { PageItemApi } from 'api/PageItemApi';
import { RawDraftContentState } from 'draft-js';
import { PageItemAbstractMapper } from 'mapper/PageItemAbstractMapper';
import { PageItemKindMapper } from 'mapper/PageItemMapper';
import { PageItemModel } from 'api/dto/PageItem.dto';
import { PageItemKind } from 'model/PageItemKind';
import { TextWidget } from 'model/TextWidget';

export class TextWidgetMapper
  implements PageItemKindMapper<TextWidget, PageItemApi.TextWidgetEntry>
{
  serialize(model: TextWidget): PageItemApi.TextWidgetEntry {
    return {
      ...PageItemAbstractMapper.serialize(model),
      content: JSON.stringify(model.content),
      htmlContent: model.htmlContent,
    };
  }

  deserialize(entry: PageItemApi.TextWidgetEntry): TextWidget {
    let content: RawDraftContentState;

    try {
      content = JSON.parse(entry.content);
    } catch (e) {
      // tslint:disable-next-line
      console.error(e);
    }

    return {
      ...PageItemAbstractMapper.deserializeShape(entry),
      content: content,
      htmlContent: entry.htmlContent,
    };
  }

  supportsSerialize(model: PageItemModel): boolean {
    return model.kind === PageItemKind.TextWidget;
  }

  supportsDeserialize(entry: PageItemApi.ItemEntry): boolean {
    return entry.kind === PageItemKind.TextWidget;
  }
}
